import { useSelector } from 'react-redux';
import Loader from 'src/common/Loader';
import { isTyreManagementV2Enabled } from 'src/utils/tyreManagementFeature';
import VehicleListPage from 'src/features/vehicle-list/VehicleListPage';
import LegacyVehicles from './LegacyVehicles';

/**
 * Keep the original vehicle workflow as the dark-launch fallback. The V2
 * vehicle register is intentionally mounted only after the company setting
 * has explicitly enabled Tyre Management V2.
 */
const Vehicles = () => {
  const { appSettings, appSettingsLoaded } = useSelector((state) => state.settings);

  if (!appSettingsLoaded) return <Loader />;

  return isTyreManagementV2Enabled(appSettings)
    ? <VehicleListPage />
    : <LegacyVehicles />;
};

export default Vehicles;
